import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=fdf16c24&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=fdf16c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf16c24",
  null
  
)

export default component.exports